import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=cc0ca624&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=cc0ca624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0ca624",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc0ca624')) {
      api.createRecord('cc0ca624', component.options)
    } else {
      api.reload('cc0ca624', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=cc0ca624&scoped=true&", function () {
      api.rerender('cc0ca624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/documents/Form.vue"
export default component.exports